import { createSelector } from 'reselect';

const getAgentTeams = (store) => store.agent_teams;
const agentTeamsSelectorInputs = [getAgentTeams];
const agentTeamsSelectorFunc = (agent_teams) =>
  agent_teams ? agent_teams : [];

export const selectAgentTeams = createSelector(
  agentTeamsSelectorInputs,
  agentTeamsSelectorFunc
);
